import axios from 'axios';

export default {
    /**
     * Загружает историю заказов для текущего пользователя
     * @param success
     */
    async loadOderHistory(success) {
        await axios.get('/api/order-history/')
            .then(response => success(response.data))
            .catch(err => console.log(err));
    },

    /**
     * Загружает историю заказов для текущего пользователя
     * @param orderId
     * @param success
     */
    async loadOderDetail(orderId, success) {
        await axios.get(`/api/order-history/${orderId}`)
            .then(response => success(response.data.data))
            .catch(err => console.log(err));
    },
}